module.exports = __webpack_public_path__ + "img/07515384000477.d0912029.png";